<template>
  <div class="flex min-h-full flex-1">
    <slot />
  </div>
</template>

<script setup lang="ts" />
